import Index from '@tunnel-components/@pages/administration/versionning/container';


/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/versionning/index.ts